import qs from 'qs';
import * as constType from '@js/constants/actionsTypes';
import { finalProductData, finalPrdPageBrandStyle } from '@js/controller/ProductController';
import {
  // apiGetSimpleProductData,
  // apiPostDeleteBrowserProduct,
  apiGetIndexMiniCartJson,
  apiPostAddToCart,
  apiPostAddToFavorite,
  apiPostRemoveToFavorite,
  apiPostAddWriteReview,
  // apiPostDeleteAllBrowserProduct,
  // apiGetPointOfServices,
  // apiGetCouponListForProduct,
  // apiPostAddProductArrivalNotice,
  // apiPostRemoveProductArrivalNotice,
} from './testJsonApi';
// import { errorHandle } from './https';

const { CSRFToken } = window;

const productMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    // 獲取 prdPageBrandStyle 區分 元鍋John‘s 和 MMM 商品頁的變數
    case 'MID_GET_PRD_PAGE_BRAND_STYLE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_PRD_PAGE_BRAND_STYLE,
        payload: finalPrdPageBrandStyle,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // 獲取產品信息
    case 'MID_GET_PRODUCT_DATA': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_PRODUCT_DATA,
        payload: finalProductData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // 加入喜愛
    case 'MID_ADD_TO_FAVORITE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      const addToFavoriteRequest = `sku=${action.payload}&CSRFToken=${CSRFToken}`;
      apiPostAddToFavorite('post', addToFavoriteRequest)
        .then((res) => {
          const response = res.data;

          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          if (response.msg === '操作成功' && response.path !== '') {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            // 未登入要轉導 path
            window.location.href = response.path;
          } else {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: response.msg,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
            window.location.reload();
          }
        })
        .catch((err) => {
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });
      return next(action);
    }
    // 取消喜愛
    case 'MID_REMOVE_TO_FAVORITE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      const removeToFavoriteRequest = `sku=${action.payload}&CSRFToken=${CSRFToken}`;
      apiPostRemoveToFavorite('post', removeToFavoriteRequest)
        .then((removeToFavoriteRes) => {
          const response = removeToFavoriteRes.data;
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: response.msg,
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
          // 成功要 reload 畫面才會更新
          window.location.reload();
        })
        .catch((err) => {
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });
      return next(action);
    }
    // 加入購物車
    case 'MID_POST_ADD_TO_CART_FOR_PRODUCT_PAGE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      const additionalPurchases = JSON.stringify(
        action.payload.additionalPurchases,
      );
      const request = {
        productCodePost: action.payload.productCode,
        qty: action.payload.qty,
        catePath: action.payload.catePath,
        CSRFToken,
        changePoint: action.payload.changePoint,
        deliveryMode: action.payload.deliveryMode,
        deliveryCost: action.payload.deliveryCost,
      };

      // 因為 additionalPurchases 這欄經過 qs 會把中括號也解析所以要特別塞
      const postRequest = `${qs.stringify(
        request,
      )}&additionalPurchases=${additionalPurchases}`;

      apiPostAddToCart('post', postRequest)
        .then((addToCartRes) => {
          const response = JSON.parse(addToCartRes.data);
          const returnCode = response.rtnCode;
          const returnMessage = response.rtnMsg;
          if (returnCode === 1) {
            store.dispatch({
              type: constType.UPDATE_ADD_TO_CART_RESPONSE,
              payload: response,
            });
            apiGetIndexMiniCartJson('get').then((getMiniCartRes) => {
              let miniCartResponse = JSON.parse(getMiniCartRes.data);
              miniCartResponse = miniCartResponse.rtnJson;
              store.dispatch({
                type: constType.UPDATE_MINICARTDATA_DATA,
                payload: miniCartResponse,
              });
              store.dispatch({
                type: constType.CHANGE_EFFECT_ISLOADING,
                payload: false,
              });
            });
          } else {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '',
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: returnMessage,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          }
        })
        .catch((error) => {
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });

      return next(action);
    }
    // 立即購買
    case 'MID_POST_INSTANT_ADD_TO_CART_FOR_PRODUCT_PAGE': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      const additionalPurchases = JSON.stringify(
        action.payload.additionalPurchases,
      );
      const request = {
        productCodePost: action.payload.productCode,
        qty: action.payload.qty,
        catePath: action.payload.catePath,
        CSRFToken,
        changePoint: action.payload.changePoint,
        deliveryMode: action.payload.deliveryMode,
        deliveryCost: action.payload.deliveryCost,
      };

      // 因為 additionalPurchases 這欄經過 qs 會把中括號也解析所以要特別塞
      const postRequest = `${qs.stringify(
        request,
      )}&additionalPurchases=${additionalPurchases}`;

      apiPostAddToCart('post', postRequest)
        .then((addToCartRes) => {
          const response = JSON.parse(addToCartRes.data);
          const returnCode = response.rtnCode;
          const returnMessage = response.rtnMsg;
          if (returnCode === 1) {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            window.location.href = '/cart';
          } else {
            store.dispatch({
              type: constType.CHANGE_EFFECT_ISLOADING,
              payload: false,
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '',
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: returnMessage,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          }
        })
        .catch((error) => {
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });

      return next(action);
    }
    // 提交商品評價信息
    case 'MID_POST_ADD_WRITE_REVIEW': {
      const { sku } = action.payload;
      const request = {
        sku,
        comment: action.payload.comment,
        rating: action.payload.rating,
        CSRFToken,
      };
      const postRequest = qs.stringify(request);
      apiPostAddWriteReview('post', sku, postRequest)
        .then((addToReviewRes) => {
          const response = JSON.parse(addToReviewRes.data);
          const returnCode = response.rtnCode;
          const returnMessage = response.rtnMsg;
          if (returnCode === '-1') {
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '',
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: returnMessage,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          } else if (returnCode === '1') {
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '',
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '評論已完成，謝謝。',
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          }
        })
        .catch((err) => {
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });

      return next(action);
    }
    case 'MID_ADD_TO_CART': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      // 打完購物車成功再去打小購物車資料
      const productCode = action.payload.sku;
      const { qty } = action.payload;
      // 如果沒有回傳catePath用預設值
      const catePath = action.payload.catePath || 'aqUjVybZ0X1UwfInWsF6Bw==';
      const addToCartRequest = `productCodePost=${productCode}&qty=${qty}&catePath=${catePath}&CSRFToken=${CSRFToken}`;
      apiPostAddToCart('post', addToCartRequest)
        .then((addToCartRes) => {
          const response = JSON.parse(addToCartRes.data);
          const returnMessage = response.rtnMsg;
          if (response.rtnCode === 1) {
            store.dispatch({
              type: constType.UPDATE_ADD_TO_CART_RESPONSE,
              payload: response,
            });
            apiGetIndexMiniCartJson('get').then((getMiniCartRes) => {
              let miniCartResponse = JSON.parse(getMiniCartRes.data);
              miniCartResponse = miniCartResponse.rtnJson;
              store.dispatch({
                type: constType.UPDATE_MINICARTDATA_DATA,
                payload: miniCartResponse,
              });
            });
          } else {
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: '',
            });
            store.dispatch({
              type: constType.UPDATE_API_RESPONSE_MESSAGE,
              payload: returnMessage,
            });
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
          }
        })
        .catch((err) => {
          // const httpStatus = err.response.status;
          // const errorMsg = err.response.data.message;
          // errorHandle(httpStatus, errorMsg);
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '',
          });
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE_MESSAGE,
            payload: '系統錯誤請稍後再試',
          });
          store.dispatch({
            type: constType.SHOW_EXCEPTION_MODAL,
            payload: true,
          });
        });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // case 'MID_UPDATE_SIMPLEPRODUCTLIST': {
    //   const postData = action.payload;
    //   // 判斷一下如果現在傳空的資料進來要可以處理
    //   if (!postData || postData === 'null' || postData === null) {
    //     return next(action);
    //   }

    //   if (postData === '') {
    //     store.dispatch({
    //       type: constType.UPDATE_SIMPLEPRODUCTLIST,
    //       payload: [],
    //     });
    //     return next(action);
    //   }

    //   apiGetSimpleProductData('post', postData)
    //     .then((res) => {

    //       if (res.data.status !== 'Y') {

    //       } else {
    //         /** 預設回傳格式 res.data 為
    //          *  data: [] 實際商品資訊
    //          *  status: Y/N 到底打了成功還是失敗
    //          *  可以補做的可以篩一下一定要保證 20 個紀錄以內
    //          */
    //         store.dispatch({
    //           type: constType.UPDATE_SIMPLEPRODUCTLIST,
    //           payload: res.data.data,
    //         });
    //         // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
    //       }
    //     })
    //     .catch((err) => {
    //       store.dispatch({
    //         type: constType.CHANGE_EFFECT_ISLOADING,
    //         payload: false,
    //       });

    //       const httpStatus = err.response.status;
    //       const errorMsg = err.response.data.message;
    //       errorHandle(httpStatus, errorMsg);
    //     });
    //   return next(action);
    // }
    // case 'MID_DELETE_BROWSERPRODUCT': {
    //   const bodyFormData = new FormData();
    //   bodyFormData.append('productCode', action.payload);
    //   apiPostDeleteBrowserProduct('post', bodyFormData)
    //     .then((deletedRes) => {

    //       const response = JSON.parse(deletedRes.data);
    //       const responseSku = response.browsedProduct;
    //       if (responseSku === '') {
    //         store.dispatch({
    //           type: constType.UPDATE_SIMPLEPRODUCTLIST,
    //           payload: [],
    //         });
    //       } else if (response.rtnCode === 1 && responseSku !== '') {
    //         apiGetSimpleProductData('post', responseSku)
    //           .then((res) => {

    //             if (res.data.status === 'Y') {
    //               store.dispatch({
    //                 type: constType.UPDATE_SIMPLEPRODUCTLIST,
    //                 payload: res.data.data,
    //               });
    //             }
    //           })
    //           .catch(() => {

    //           });
    //       }
    //     })
    //     .catch(() => {

    //       // const httpStatus = err.response.status;
    //       // const errorMsg = err.response.data.message;
    //       // errorHandle(httpStatus, errorMsg);
    //     });
    //   return next(action);
    // }
    // case 'MID_DELETE_ALL_BROWSERPRODUCT': {
    //   const bodyFormData = new FormData();
    //   bodyFormData.append('type', 'all');
    //   apiPostDeleteAllBrowserProduct('post', bodyFormData).then((res) => {
    //     const response = JSON.parse(res.data);
    //     if (response.rtnCode === 1) {
    //       document.cookie = 'browsedProducts=';
    //       store.dispatch({
    //         type: constType.UPDATE_SIMPLEPRODUCTLIST,
    //         payload: [],
    //       });
    //     }
    //   });
    //   return next(action);
    // }
    // case 'MID_GET_POINT_OF_SERVICES': {
    //   const locationData = action.payload.location;
    //   const { sku } = action.payload;
    //   const bodyFormData = new FormData();
    //   bodyFormData.append('latitude', locationData.latitude);
    //   bodyFormData.append('longitude', locationData.longitude);
    //   store.dispatch({
    //     type: constType.CHANGE_EFFECT_ISLOADING,
    //     payload: true,
    //   });
    //   apiGetPointOfServices('post', sku, bodyFormData).then((res) => {
    //     const response = res.data;
    //     if (response.rtnCode === 1) {
    //       store.dispatch({
    //         type: constType.GET_POINT_OF_SERVICES,
    //         payload: response.data,
    //       });

    //       store.dispatch({
    //         type: constType.CHANGE_EFFECT_ISLOADING,
    //         payload: false,
    //       });
    //     }
    //   })
    //   .catch((err) => {
    //     store.dispatch({
    //       type: constType.CHANGE_EFFECT_ISLOADING,
    //       payload: false,
    //     });

    //   });
    //   return next(action);
    // }
    // case 'MID_GET_COUPON_LIST_FOR_PRODUCT': {
    //   store.dispatch({
    //     type: constType.CHANGE_EFFECT_ISLOADING,
    //     payload: true,
    //   });
    //   const sku = action.payload;
    //   // 這支 api 沒有 rtnCode
    //   apiGetCouponListForProduct('get', sku).then((res) => {
    //     const response = res.data;
    //     const { status } = res;
    //     if (status === 200) {
    //       if (response.length !== 0) {
    //         store.dispatch({
    //           type: constType.GET_COUPON_LIST_FOR_PRODUCT,
    //           payload: response,
    //         });
    //       } else if (response.length === 0) {
    //         // store.dispatch({ type: constType.UPDATE_API_RESPONSE_MESSAGE, payload: '' });
    //         // store.dispatch({ type: constType.UPDATE_API_RESPONSE_MESSAGE, payload: '無適用之折價券' });
    //         // store.dispatch({ type: constType.SHOW_EXCEPTION_MODAL, payload: true });
    //       }
    //     }
    //     store.dispatch({
    //       type: constType.CHANGE_EFFECT_ISLOADING,
    //       payload: false,
    //     });
    //   })
    //   .catch((err) => {

    //     store.dispatch({
    //       type: constType.CHANGE_EFFECT_ISLOADING,
    //       payload: false,
    //     });

    //   });
    //   return next(action);
    // }
    // case 'MID_ADD_PRODUCT_ARRIVAL_NOTICE': {
    //   const sku = action.payload;
    //   const request = {
    //     sku,
    //     CSRFToken,
    //   };
    //   const postRequest = qs.stringify(request);
    //   apiPostAddProductArrivalNotice('post', postRequest)
    //     .then((res) => {

    //       const response = res.data;
    //       const returnStatus = response.status;
    //       const returnMessage = response.msg;
    //       const returnPath = response.path;
    //       // if (returnStatus) {
    //       store.dispatch({
    //         type: constType.UPDATE_API_RESPONSE_MESSAGE,
    //         payload: '',
    //       });
    //       // }
    //       if(returnMessage === '操作成功' && returnPath !== '') {
    //         window.location.href=returnPath;
    //       }else{
    //         store.dispatch({
    //           type: constType.UPDATE_API_RESPONSE_MESSAGE,
    //           payload: returnMessage,
    //         });
    //         store.dispatch({
    //           type: constType.SHOW_EXCEPTION_MODAL,
    //           payload: true,
    //         });
    //         window.location.reload();
    //       }
    //     })
    //     .catch(() => {

    //     });

    //   return next(action);
    // }
    // case 'MID_REMOVE_PRODUCT_ARRIVAL_NOTICE': {
    //   const sku = action.payload;
    //   const request = {
    //     sku,
    //     CSRFToken,
    //   };
    //   const postRequest = qs.stringify(request);
    //   apiPostRemoveProductArrivalNotice('post', postRequest)
    //     .then((res) => {

    //       const response = res.data;
    //       const returnStatus = response.status;
    //       // if (returnStatus) {
    //       store.dispatch({
    //         type: constType.UPDATE_API_RESPONSE_MESSAGE,
    //         payload: '',
    //       });
    //       store.dispatch({
    //         type: constType.UPDATE_API_RESPONSE_MESSAGE,
    //         payload: '已成功取消貨到通知',
    //       });
    //       store.dispatch({
    //         type: constType.SHOW_EXCEPTION_MODAL,
    //         payload: true,
    //       });
    //       // }
    //       window.location.reload();
    //     })
    //     .catch(() => {

    //     });

    //   return next(action);
    // }
    default:
      return next(action);
  }
};

export default productMiddleware;
